import { Formik } from 'formik';
import { createSelector } from '@reduxjs/toolkit';
import { useIsMobile } from '@client/hooks/dom.hooks';
import { useDispatch, useSelector } from '@client/hooks/redux.hooks';
import { getSelectedProfileType } from '@client/selectors/helpers/profile';
import { ProfileTypes } from '@sda/enums';
import { Form } from '@client/components/forms/Form';
import { AlgoliaIndices } from '@sda/enums/algolia';
import { useMountEffect } from '@client/hooks/utils.hooks';
import { resetMapState } from '@client/slices/features/map.reducer';
import { createMatchSelector } from '@client/selectors/helpers/router';
import { Desktop } from './Main/Desktop';
import { FetchShowCalls } from './Main/FetchShowCalls';
import { PinTypes } from './Main/interfaces';
import { FetchProfiles } from './Main/FetchShowCalls/FetchProfiles';
import { Mobile } from './Main/Mobile';

const connectModeSelector = createMatchSelector({
  path: '/connect/:mode',
});

const getDefaultSearchType = createSelector(
  connectModeSelector,
  getSelectedProfileType,
  (connectMatch, selectedProfileType) => {
    const mode = connectMatch && connectMatch.params.mode;

    if (mode === 'artists') {
      return ProfileTypes.ACT;
    }

    if (mode === 'hosts') {
      return ProfileTypes.VENUE;
    }

    if (selectedProfileType === ProfileTypes.ACT) {
      return ProfileTypes.VENUE;
    }

    return ProfileTypes.ACT;
  },
);

export const Connect = () => {
  const isMobile = useIsMobile();
  const defaultSearchType = useSelector(getDefaultSearchType);
  const dispatch = useDispatch();

  useMountEffect(() => {
    dispatch(resetMapState());

    return () => {
      dispatch(resetMapState());
    };
  });

  return (
    <Formik
      onSubmit={() => {}}
      initialValues={{
        query: '',
        compiledAddress: '',
        latLng: null,
        googlePlaceId: '',
        filter: [],
        hasPA: false,
        requiresPA: [],
        venueType: [],
        dateRange: [],
        primaryGenre: [],
        pinTypes: [PinTypes.SHOWCALLS, PinTypes.PROFILES],
        searchType: defaultSearchType,
      }}
    >
      {({ values }) => (
        <Form>
          {values.pinTypes.includes(PinTypes.PROFILES) && (
            <FetchProfiles
              index={values.searchType === ProfileTypes.ACT ? AlgoliaIndices.VENUES : AlgoliaIndices.ACTS}
            />
          )}

          <FetchShowCalls />

          {isMobile ? <Mobile /> : <Desktop />}
        </Form>
      )}
    </Formik>
  );
};

export default Connect;
